import { Project } from '@/app/api';
import { pushAdditionalGaIds } from '@/app/hooks/useAnalytics/push-additional-ga-ids';
import { pushToDataLayer } from '@/app/hooks/useAnalytics/push-to-data-layer';
import {
  getProjectBrand,
  getProjectCategory,
  GoogleTagManagerEventNames,
  PageTypes,
} from '@/app/hooks/useAnalytics/types';
import { envs } from '@/app/utils/envs';
import mixpanel from 'mixpanel-browser';

type PushProjectDetailViewEventParams = {
  project: Project;
  areStatisticsCookiesAllowed: boolean;
  isSubscribed: boolean;
  abGroup: string;
  userId?: string;
};

export const pushProjectDetailViewEvent = (params: PushProjectDetailViewEventParams) => {
  if (!params.areStatisticsCookiesAllowed) {
    if (envs.isAnalyticInDebugMode) {
      console.log('Skipping project detail view, because statistics cookies are not allowed');
    }
    return;
  }

  publicMixpanelEvent(params);
  publishGtmEvent(params);
};

const publicMixpanelEvent = ({ project, isSubscribed, userId }: PushProjectDetailViewEventParams) => {
  mixpanel.track_pageview({
    page_type: PageTypes.ProjectDetail,
    project_id: project.numericId,
    project_mode: project.settings.modeGroup,
    project_status: project.state.status,
    subscription_activated: isSubscribed,
    $user_id: userId,
  });
};

const publishGtmEvent = ({ project, abGroup }: PushProjectDetailViewEventParams) => {
  if (!envs.isGtmEnabled) {
    if (envs.isAnalyticInDebugMode) {
      console.log('Skipping Google Tag Manager - DonationFormPageViewEvent');
    }
    return;
  }

  const gtmObject = {
    ecommerce: {
      items: [
        {
          item_id: project.numericId,
          item_name: project.content.baseName,
          item_brand: getProjectBrand(project),
          item_category: getProjectCategory(project),
          abGroup,
        },
      ],
    },
  };

  if (envs.isAnalyticInDebugMode) {
    console.log('Google Tag Manager - DonationFormPageViewEvent', gtmObject);
  }

  pushAdditionalGaIds(GoogleTagManagerEventNames.ViewItem, project);
  pushToDataLayer(gtmObject);
};
